import { Badge, Stack, Typography } from "@mui/material";

function LinkStatusCard({
    label,
    value,
    icon,
    action
}) {
    return (
        <Stack
            p={2}
            direction={"row"}
            onClick={action}
            sx={{
                background: "#fff7f0",
                minWidth: 200,
                borderRadius: 2,
                cursor: Number(value) > 0 ? "pointer" : "default",
                boxShadow: 1
            }}
        >
            {
                icon ? icon : null
            }

            <Stack
                rowGap={1.25}
            >
                <Typography>
                    {label}
                </Typography>

                <Badge>
                    {value}
                </Badge>
            </Stack>
        </Stack>
    )
}

export default LinkStatusCard;